import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase';

export async function saveActorSnapshot(actor, projectId) {
  if (!actor || !actor.nombre) return;

  const snapshot = {
    actorId:               actor.id || null,
    actorNombre:           actor.nombre,
    projectId:             projectId || actor.projectId || null,
    fecha:                 new Date().toISOString(),

    // Estado cognitivo en este momento
    estado:                actor.estado || '',
    riesgo:                actor.riesgo || '',
    influencia:            actor.influencia || '',
    estadoTerritorial:     actor.estadoTerritorial || '',
    sensibilidadTerritorial: actor.sensibilidadTerritorial || '',
    activacionTerritorial: actor.activacionTerritorial || '',
    convergenciaNarrativa: actor.convergenciaNarrativa || '',
    capacidadPropagacion:  actor.capacidadPropagacion || '',
    legitimidadTerritorial: actor.legitimidadTerritorial || '',
    narrativaDominante:    actor.narrativaDominante || '',

    // Scoring calculado por el engine si existe
    IVT: actor._vita?.scoring?.IVT ?? null,
    IST: actor._vita?.scoring?.IST ?? null,
    IAT: actor._vita?.scoring?.IAT ?? null,
    IPN: actor._vita?.scoring?.IPN ?? null,
    ICT: actor._vita?.scoring?.ICT ?? null,

    // Estado calculado por el engine
    estadoEngine: actor._vita?.state?.state || ''
  };

  try {
    await addDoc(collection(db, 'snapshots'), snapshot);
  } catch (error) {
    console.error('Error guardando snapshot:', error);
  }
}